<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/nXpTMv/tc-custom/9780226772837.jpg?1722582194360" alt="This image is the cover for the book Handle, The Parker Novels"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Handle, The Parker Novels
      </h1>
      <p class="bookDescription body article font2">
        <p>In <i>The Handle</i>, Parker is enlisted by the mob to knock off an island casino guarded by speedboats and heavies, forty miles from the Texas coast. With double-crosses and double-dealings from the word go, Parker knows the line between success and failure on this score would be exactly the length of the barrel of a .38.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Richard Stark, Luc Sante
      </h2>
      
      <p class="authorDescription body article"><B>Richard Stark</B> was one of the many pseudonyms of Donald E. Westlake (1933-2008), a prolific author of noir crime fiction. In 1993 the Mystery Writers of America bestowed the society’s highest honor on Westlake, naming him a Grand Master.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The University of Chicago Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?44b8a543